import styled from "styled-components";
import theme from "./theme";

export default styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${theme.gap};
`;
